/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './pda-receiving.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '../../../../../app/agatextscreens/pda/receiving/pda-receiving.component';
import * as i4 from '../../../../../app/shared/services/authentication.service';
const styles_PdaReceivingComponent:any[] = [i0.styles];
export const RenderType_PdaReceivingComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PdaReceivingComponent,data:{}});
export function View_PdaReceivingComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(16777216,
      (null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(212992,(null as any),0,i2.RouterOutlet,
      [i2.ChildrenOutletContexts,i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,
          (null as any)],i1.ChangeDetectorRef],(null as any),(null as any)),(_l()(),
      i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export function View_PdaReceivingComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-pda-receiving',
      ([] as any[]),(null as any),(null as any),(null as any),View_PdaReceivingComponent_0,
      RenderType_PdaReceivingComponent)),i1.ɵdid(114688,(null as any),0,i3.PdaReceivingComponent,
      [i4.AuthenticationService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const PdaReceivingComponentNgFactory:i1.ComponentFactory<i3.PdaReceivingComponent> = i1.ɵccf('app-pda-receiving',
    i3.PdaReceivingComponent,View_PdaReceivingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9yZWNlaXZpbmcvcGRhLXJlY2VpdmluZy5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9yZWNlaXZpbmcvcGRhLXJlY2VpdmluZy5jb21wb25lbnQudHMiLCJuZzovLy9DOi9Vc2Vycy9vcmlvbi9Qcm9qZWN0cy9zaW1wbGljaXR5RW5naW5lL3ZhbG11c3QvdmFsbXVzdGZlL3NyYy9hcHAvYWdhdGV4dHNjcmVlbnMvcGRhL3JlY2VpdmluZy9wZGEtcmVjZWl2aW5nLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9zcmMvYXBwL2FnYXRleHRzY3JlZW5zL3BkYS9yZWNlaXZpbmcvcGRhLXJlY2VpdmluZy5jb21wb25lbnQudHMuUGRhUmVjZWl2aW5nQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXHJcbjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cclxuIiwiPGFwcC1wZGEtcmVjZWl2aW5nPjwvYXBwLXBkYS1yZWNlaXZpbmc+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUEsdUNBQ0E7TUFBQTtNQUFBLG1EQUFBO01BQUE7VUFBQSxrRUFBK0I7YUFBQTtJQUEvQjs7OztvQkNEQTtNQUFBO3NDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/pda/receiving/pda-receiving.component.ngfactory.ts